module.exports = __webpack_public_path__ + "static/media/5th_banner_item2.4065ff0a.png";